import React from 'react'
import { toBooleanOrNull } from "lib/helpers/parent/forms"

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      createAccount, // via withMutation
      form, // via withRedux
      token // via withState
    } = props

    // perform GraphQL mutation
    const handleSubmit = e => {
      e.preventDefault()

      createAccount({
        variables: {
          input: {
            // account attributes
            email: form.email,
            password: form.password,
            // form-only attributes
            passwordConfirmation: form.passwordConfirmation,
            // parent attributes
            firstName: form.firstName,
            lastName: form.lastName,
            relationshipToCampers: form.relationshipToCampers,
            legalGuardian: toBooleanOrNull(form.legalGuardian),
            primaryPhone: form.primaryPhone,
            alternatePhone: form.alternatePhone,
            streetAddress: form.streetAddress,
            city: form.city,
            region: form.region,
            country: form.country,
            postalCode: form.postalCode,
            primaryPhoneType: form.primaryPhoneType,
            smsOptIn: ['true', true].includes(form.smsOptIn),
            smsOptedAt: form.smsOptedAt
          },
          preferencesInput: {
            onlineOnly: form.onlineOnly === 'true',
            newProjectNotifications: true
          },
          verificationInput: {
            turnstileToken: token
          }
        }
      })
    }

    return <WrappedComponent handleSubmit={handleSubmit} {...props} />
  }
}

export default withEventHandlers
